import React from 'react';
import { UserSimple } from '~/types/models';
import Workspace from '~/App/Modules/Workspaces/Types/Workspace';
import { TaskCreationAction } from './TaskCreationWrapper';

export interface TaskCreationContext {
  loading?: boolean;
  errorFields: string[];
  setErrorFields: (errorFields: string[]) => void;
  email: string;
  setEmail: (email: string) => void;
  name: string;
  setName: (name: string) => void;
  description: string;
  setDescription: (description: string) => void;
  assignee: UserSimple | undefined;
  setAssignee: (assignee: UserSimple | undefined) => void;
  onSubmit: (action: TaskCreationAction) => void;
  workspace?: Workspace | null;
}

export default React.createContext<TaskCreationContext>(
  {} as unknown as TaskCreationContext
);
